import React from 'react';
import DynaModal from "../../Modal/DynaModal";
import _axios from "../../../httpService";
import {toast} from "react-toastify";
import {prefixUrl} from "../../../utils/utilsData";

const ModalConfirmOrder = ({onClose, selectedRow, setUpdateTableData}) => {

  function confirmOrder(row) {
    const pkValue = row.getData()["primaryKey"];
    
    // We need to fetch the full data first, then update the status, 
    // because the backend POST endpoint updates the whole havale record.
    _axios.get(`${prefixUrl()}/cheeka/submit_order/?id_havale=${pkValue}`)
      .then((res) => {
        if (res.data.status) {
          const payload = {
            ...res.data.data,
            havale_status: 8 // Status 8 is "تایید" according to backend index.php
          };

          _axios.post(`${prefixUrl()}/cheeka/submit_order/`, payload)
            .then((response) => {
              if (response.data.status) {
                toast.success("سفارش با موفقیت تایید شد");
                setUpdateTableData(prev => prev + 1); // Refresh table
                onClose();
              } else {
                toast.error(response.data.message);
              }
            })
            .catch((error) => {
              console.log(error);
              toast.error("خطا در تایید سفارش");
            });
        } else {
          toast.error("خطا در دریافت اطلاعات سفارش");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("خطا در ارتباط با سرور");
      });
  }

  const icon = (
    <svg width="100" height="100" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="32" fill="#4CAF50" />
      <path fill="#fff" d="M27.5 42.5l-9.5-9.5 2.1-2.1 7.4 7.4 16.4-16.4 2.1 2.1z" />
    </svg>
  );

  return (
    <DynaModal onClose={onClose} className={'small-modal-ravan-hessab size-modal-delete-tafzil'}>
      <div className="header-modal">
        <p>تایید سفارش</p>
        <div onClick={onClose} style={{cursor: 'pointer'}}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>

      <div className="content-modal">
        <div className="box-delete">
          {icon}
          <p>آیا از تایید این سفارش مطمئن هستید؟</p>
        </div>
      </div>

      <div className="button-modal">
        <button onClick={onClose} className="cancel-modal">انصراف</button>
        <button className="accept-modal" style={{backgroundColor: '#4CAF50'}} onClick={() => confirmOrder(selectedRow)}>تایید نهایی</button>
      </div>
    </DynaModal>
  );
};

export default ModalConfirmOrder;
